// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --background: transparent;
  position: absolute;
}

.logo {
  width: calc(56 * var(--width-ratio));
  height: auto;
  border-radius: calc(10 * var(--width-ratio));
}

.badge-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: calc(12 * var(--width-ratio));
}

.store-badge {
  height: calc(48 * var(--width-ratio));
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/download-app-modal/download-app-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF;;AAIA;EACE,oCAAA;EACA,YAAA;EACA,4CAAA;AADF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;AAFF;;AAKA;EACE,qCAAA;EACA,eAAA;AAFF","sourcesContent":["ion-toolbar {\n  --background: transparent;\n  position: absolute;\n}\n\n// logo 需固定尺寸：ion-col size=\"2\" 是百分比欄寬，modal 變寬時 logo 會跟著脹大\n// （iPad full width 實測脹到 118px），把內容撐出配置高度\n.logo {\n  width: calc(56 * var(--width-ratio));\n  height: auto;\n  border-radius: calc(10 * var(--width-ratio));\n}\n\n// 商店徽章列：單一平台置中一顆，桌面版兩顆並排\n.badge-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: calc(12 * var(--width-ratio));\n}\n\n.store-badge {\n  height: calc(48 * var(--width-ratio));\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
